export enum DeviceType {
  Pump = 'pump',
  Vacuum = 'vacuum',
  General = 'general',
  CentrifugalAndPowerSensor = 'centrifugal_powerSensor',
  FixedSpeedAndPowerSensor = 'fixedSpeed_powerSensor',
  VariableSpeedDriveAndPowerSensor = 'powerSensor_variableSpeedDrive',
  FlowAndPressureSensor = 'flowSensor_pressureSensor',
  FlowSensor = 'flowSensor',
  WaterFlowSensor = 'waterFlowSensor',
  WaterPressureSensor = 'waterPressureSensor',
  PressureSensor = 'pressureSensor',
  PowerSensor = 'powerSensor',
  DewpointSensor = 'dewpointSensor',
  DewpointAndPressureSensor = 'dewpointSensor_pressureSensor',
  AirTemperatureSensor = 'airTemperatureSensor',
  WaterTemperatureSensor = 'waterTemperatureSensor',
  FixedSpeed = 'fixedSpeed',
  VariableSpeedDrive = 'variableSpeedDrive',
  Centrifugal = 'centrifugal',
  Booster = 'booster',
  RefrigeratedAirDryer = 'refrigeratedAirDryer',
  DesiccantAirDryer = 'desiccantAirDryer',
  WetAirTank = 'wetAirTank',
  DryAirTank = 'dryAirTank',
  ConverterDigitalAnalogToModbus = 'converterDigitalAnalogToModbus',
  PLC = 'PLC',
  AirFilter = 'airFilter',
  ProductionFloor = 'productionFloor',
  Pipe = 'pipe',
  ProportionalValve = 'proportionalValve',
  OpenCloseValve = 'openCloseValve',
  SpillValve = 'spillValve',
  Connector = 'connector',
  AmbientHumiditySensor = 'ambientHumiditySensor',
  AmbientTemperatureSensor = 'ambientTemperatureSensor',
  AmbientHumidityAndTemperatureSensor = 'ambientHumiditySensor_ambientTemperatureSensor',
  AmbientHumidityAndTemperatureAndDewpointSensor = 'ambientHumiditySensor_ambientTemperatureSensor_dewpointSensor',
  InfluentFlowSensor = 'influentFlowSensor',
  DissolvedOxygenSensor = 'dissolvedOxygenSensor',
  PhSensor = 'phSensor',
  AmmoniaAmmoniumSensor = 'ammoniaAmmoniumSensor',
  NitrateSensor = 'nitrateNO3Sensor',
  NitriteSensor = 'nitriteNO2Sensor',
  OxidationReductionPotentialSensor = 'oxidationReductionPotentialSensor',
  Blower = 'blower',
  AerationBasin = 'aerationBasin',
}

export const compressorTypes = [
  DeviceType.FixedSpeed,
  DeviceType.VariableSpeedDrive,
  DeviceType.Centrifugal,
  DeviceType.CentrifugalAndPowerSensor,
  DeviceType.FixedSpeedAndPowerSensor,
  DeviceType.VariableSpeedDriveAndPowerSensor,
  DeviceType.Blower,
];

export const comboCompressorAndPowerSensorDeviceTypes = [
  DeviceType.FixedSpeedAndPowerSensor,
  DeviceType.VariableSpeedDriveAndPowerSensor,
  DeviceType.CentrifugalAndPowerSensor,
];

export const airTankTypes = [DeviceType.DryAirTank, DeviceType.WetAirTank];

export const valveTypes = [DeviceType.OpenCloseValve, DeviceType.ProportionalValve, DeviceType.SpillValve];

export const dryerTypes = [DeviceType.RefrigeratedAirDryer, DeviceType.DesiccantAirDryer];

export const sensorTypes = [
  DeviceType.WaterFlowSensor,
  DeviceType.WaterPressureSensor,
  DeviceType.PressureSensor,
  DeviceType.PowerSensor,
  DeviceType.DewpointSensor,
  DeviceType.DewpointAndPressureSensor,
  DeviceType.AirTemperatureSensor,
  DeviceType.WaterTemperatureSensor,
  DeviceType.FlowSensor,
  DeviceType.FlowAndPressureSensor,
  DeviceType.InfluentFlowSensor,
  DeviceType.DissolvedOxygenSensor,
  DeviceType.PhSensor,
  DeviceType.AmmoniaAmmoniumSensor,
  DeviceType.NitrateSensor,
  DeviceType.NitriteSensor,
  DeviceType.OxidationReductionPotentialSensor,
];

export const universalDeviceDrawerTypes = [DeviceType.Vacuum, DeviceType.Pump, DeviceType.General];
